import React from "react";
import Grid from "@mui/material/Grid";

const TSGrid = ({ container, item, xs, sx, minHeight = 70,spacing, children, ...props }) => {
  if (container) {
    return (
      <Grid container spacing={spacing} sx={sx} {...props}>
        {children}
      </Grid>
    );
  } else if (item) {
    return (
      <Grid item xs={xs} sx={[sx]} {...props}>
        {children}
      </Grid>
    );
  } else {
    // By default, if neither container nor item prop is specified, assume it's a container
    return (
      <Grid container spacing={spacing} sx={[sx]} {...props}>
        {children}
      </Grid>
    );
  }
};

export default TSGrid;
